export interface ProcessoCadastroHistorico {
    NCODIGO: number;
    CSTATUS: string;
    DDATA: Date | undefined;
    CHORA: string;
    CCODIGOUSUARIOPROTHEUS: string;
    CCODIGOUSUARIOPROTHEUS_NOME: string;
    COBSERVACAO: string;
    NCODIGOPROCESSOCADASTRO: number;
}

export const getProcessoCadastroHistoricoDefault = (): ProcessoCadastroHistorico => {
  return {
    NCODIGO: 0,
    CSTATUS: '',
    DDATA: undefined,
    CHORA: '',
    CCODIGOUSUARIOPROTHEUS: '',
    CCODIGOUSUARIOPROTHEUS_NOME: '',
    COBSERVACAO: '',
    NCODIGOPROCESSOCADASTRO: 0,
  };
};

export interface ProcessoCadastroHistoricoList {
  items: Array<ProcessoCadastroHistorico>;
}

export const getProcessoCadastroHistoricoListDefault = (): ProcessoCadastroHistoricoList => {
  return {
    items: [getProcessoCadastroHistoricoDefault()],
  };
};